module.exports = __webpack_public_path__ + "static/media/Energy.43385fc3.svg";